import { toRole } from '../../role.js';
import { toNumber } from '../../utils/utils.js';
var AccessCodeBaseEnum;
(function (AccessCodeBaseEnum) {
    AccessCodeBaseEnum["DAY"] = "day";
    AccessCodeBaseEnum["ITEM"] = "item";
})(AccessCodeBaseEnum || (AccessCodeBaseEnum = {}));
const toAccessCodeBaseEnum = (raw) => {
    switch (raw) {
        case 'day':
            return AccessCodeBaseEnum.DAY;
        case 'item':
            return AccessCodeBaseEnum.ITEM;
        default:
            return AccessCodeBaseEnum.ITEM;
    }
};
const toAccessCodeFeature = (raw) => {
    return {
        description: raw.description || '',
        defaults: raw.defaults || '',
        enabled: !!raw.enabled,
        role: toRole(raw.role),
        params: raw.params ?? {},
        notifyBase: toAccessCodeBaseEnum(raw.notifyBase),
        notifyHour: toNumber(raw.notifyHour, 2)
    };
};
const emptyAccessCodeFeature = (enabled, role) => {
    return {
        description: '',
        defaults: '',
        enabled,
        role,
        params: {},
        notifyBase: AccessCodeBaseEnum.ITEM,
        notifyHour: 2
    };
};
// Check if the access code should be visible
const accessCodeIsVisible = (now, acFeature, startOfItem, endOfItem) => {
    if (now > endOfItem)
        return false; // Not after the item
    // Ok so now is nor or in the futuere - but is it close enough?
    if (acFeature.notifyBase === AccessCodeBaseEnum.DAY) {
        const refDate = startOfItem.startOf('day');
        return now >= refDate.plus({ hours: acFeature.notifyHour });
    }
    else {
        return now >= startOfItem.minus({ hours: acFeature.notifyHour });
    }
};
// Calculate the time when the access code should be published
const accessCodePublishTime = (acFeature, startOfItem) => {
    if (acFeature.notifyBase === AccessCodeBaseEnum.DAY) {
        return startOfItem.startOf('day').plus({ hours: acFeature.notifyHour });
    }
    else {
        return startOfItem.minus({ hours: acFeature.notifyHour });
    }
};
export { toAccessCodeFeature, emptyAccessCodeFeature, AccessCodeBaseEnum, accessCodePublishTime, accessCodeIsVisible };
//# sourceMappingURL=accessCodeFeature.js.map